'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryVideoEditor = require('./components/PrimaryVideoEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryVideoEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-video-editor/index.js
// module id = 1041
// module chunks = 4